// @flow strict

import * as React from 'react'

import type { Overdraft } from './types'
import styles from './OverdraftFeeCalculator.module.scss'
import { RATE_APR_19, RATE_APR_29, RATE_APR_39 } from './constants'

type Props = {|
  arranged: Overdraft,
  unarranged: Overdraft,
  onRateChange: (event: SyntheticInputEvent<HTMLSelectElement>) => void,
  rate: string,
|}
function OverdraftFeePicker({
  arranged,
  unarranged,
  onRateChange,
  rate,
}: Props) {
  return (
    <div className={`${styles.rateField}`}>
      <label className={styles.rateFieldLabel}>
        <span className={styles.ratePickerText}>
          If you borrowed{' '}
          <span className={styles.amount}>
            £{arranged.amount.toLocaleString('en-GB')}{' '}
          </span>
          for
          <span className={styles.amount}> {arranged.days} </span>
          {arranged.days === 1 ? 'day' : 'days'}
          <br />
          from your arranged overdraft
        </span>
        {unarranged.amount > 0 && (
          <span className={styles.ratePickerText}>
            and you slip into your unarranged overdraft and borrow <br />
            <span className={styles.amount}>
              £{unarranged.amount.toLocaleString('en-GB')}{' '}
            </span>
            for
            <span className={styles.amount}> {unarranged.days} </span>
            {unarranged.days === 1 ? 'day' : 'days'}
          </span>
        )}
        <br />
        <span>
          at a rate of{' '}
          <select
            onChange={onRateChange}
            name="rate"
            className={styles.rateInput}
            value={rate}
          >
            <option value={RATE_APR_19}>19% EAR/APR</option>
            <option value={RATE_APR_29}>29% EAR/APR</option>
            <option value={RATE_APR_39}>39% EAR/APR</option>
          </select>
        </span>
      </label>
    </div>
  )
}

export default OverdraftFeePicker
